import React from 'react';
import { useSelector } from 'react-redux';
import ActivityIndicator from '../../../../components/ActivityIndicator';
import useActivateDriver from '../../../../hooks/driver/useActivateDriver';
import useRegisterRefusedData from '../../../../hooks/driver/useRegisterRefusedData';
import useUpdateRefusedData from '../../../../hooks/driver/useUpdateRefusedData';
import { ApplicationState } from '../../../../store';
import './styles.scss';
interface IFooterModal {
  handleBack: () => void;
  handleNext: () => void;
  currentStep: number;
  totalSteps: number;
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
}

const FooterModal: React.FC<IFooterModal> = ({
  handleBack,
  handleNext,
  currentStep,
  totalSteps,
  openModal,
  setOpenModal,
}) => {
  const { reasonsRefusalDraft, driverId, refusedData, status } = useSelector(
    (state: ApplicationState) => state.driver,
  );

  const { execute: executeRegisterRefusedData, loading } =
    useRegisterRefusedData();
  const { execute: executeUpdateDriverRefusedData, loading: loadingUpdate } =
    useUpdateRefusedData();
  const { execute: executeActivateDriver, loading: loadingDelete } =
    useActivateDriver();

  const handleButtonBack = () => {
    if (currentStep > 1) {
      handleBack();
    } else {
      setOpenModal(false);
    }
  };

  const handleApprove = async () => {
    await executeActivateDriver(driverId, () => {
      setOpenModal(!openModal);
    });
  };

  const handleSendRefusedReason = async () => {
    if (refusedData.length > 0) {
      await executeUpdateDriverRefusedData(
        driverId,
        reasonsRefusalDraft,
        () => {
          setOpenModal(!openModal);
        },
      );
    } else {
      await executeRegisterRefusedData(driverId, reasonsRefusalDraft, () => {
        setOpenModal(!openModal);
      });
    }
  };
  if (loading || loadingUpdate || loadingDelete) {
    return <ActivityIndicator />;
  }

  return (
    <div className="footer-modal">
      <button onClick={handleButtonBack} className="btn-back">
        Voltar
      </button>

      {currentStep === totalSteps &&
      reasonsRefusalDraft.length === 0 &&
      status !== 'Ativo' ? (
        <button className="btn-aprrove" onClick={handleApprove}>
          <span>Aprovar Cadastro</span>
        </button>
      ) : currentStep === totalSteps && reasonsRefusalDraft.length > 0 ? (
        <button className="btn-refuse" onClick={handleSendRefusedReason}>
          <span>Enviar Motivo</span>
        </button>
      ) : currentStep < totalSteps ? (
        <button onClick={() => handleNext()} className="btn-next">
          <span>Próximo</span>
        </button>
      ) : (
        <button onClick={() => setOpenModal(false)} className="btn-next">
          <span>Sair</span>
        </button>
      )}
    </div>
  );
};

export default FooterModal;
